import { normalizarRol } from './roles';
import { leerUsuario } from './legacyData';
import { empresasDelPerfil } from './accessPolicy';
export { normalizarRol } from './roles';

export function perfilOperativo(profile) {
  return !!profile && profile.activo !== false;
}

// Solo presentación/compatibilidad; nunca se lee localStorage para autorizar.
export function usuarioDePerfil(user, profile) {
  if (!user || !perfilOperativo(profile)) return null;
  profile = leerUsuario(profile, user.uid);
  if (!profile) return null;
  const empresaId = profile.empresaId;
  return {
    uid: user.uid,
    email: user.email || profile.email || '',
    nombre: profile.nombre || 'Usuario',
    rol: normalizarRol(profile.rol) || 'pendiente',
    empresaId,
    empresaNombre: profile.empresaNombre || '',
    empresasPermitidas: empresasDelPerfil(profile),
    eventosPermitidos: profile.eventosPermitidos || {},
    eventosBloqueados: profile.eventosBloqueados || {},
  };
}

export function limpiarCacheAutorizacion() {
  try {
    Object.keys(localStorage).forEach((key) => {
      if (key === 'usuario' || key.startsWith('palmarama_user_role_')) localStorage.removeItem(key);
    });
  } catch {
    // La disponibilidad de almacenamiento no concede ni revoca permisos.
  }
}
